
import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import * as uuid from 'uuid';

@Component({
  selector: 'app-app-edit',
  templateUrl: './app-edit.component.html',
  styleUrls: ['./app-edit.component.css'],
  providers: [MessageService,ConfirmationService]
})
export class AppEditComponent implements OnInit {
  action:string='';
  app:any={
    name:'',
    description:'',
    code:''
  };

  constructor(
    private apiService: ApiService,
    private messageService: MessageService,
    private router: Router,
    private route: ActivatedRoute,
    public confirmationService: ConfirmationService
  ) { }
  
  ngOnInit(): void {
      this.action=this.route.snapshot.paramMap.get('action');
      if (this.route.snapshot.paramMap.get('id')) {    
        this.apiService.get('organizationchart/getapps',{id:this.route.snapshot.paramMap.get('id')}).subscribe(data => {
          this.app=data.Result[0];
        });
      }
  }

  salva(){
    this.apiService.get('organizationchart/app_update',this.app).subscribe(data => {
      this.addSingle('success', 'Success', 'Record aggiornato');
    });
  }

  delete(){
    this.confirmationService.confirm({
        message: 'Si conferma la cancellazione dell\'app',
        accept: () => {
           this.apiService.get('organizationchart/app_delete',{id:this.route.snapshot.paramMap.get('id')}).subscribe(data => {
            this.addSingle('success', 'Success', 'Record eliminato');
          });
        }
      });
  }


  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }
  
}
